<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
       <h2 class="outside_title d-flex">
        {{ $t('appealoppsition.appeal.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('appealoppsition.title') }} > </span>
            <span class="middle_loc">{{ $t('appealoppsition.appeal.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">

          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01">
              <h2>{{ $t('appealoppsition.appeal.fields.step_01') }}</h2>
              <p>{{ $t('appealoppsition.appeal.fields.search_application') }}</p>
            </v-flex>
            <v-flex class="step_box step02 active">
              <h2>{{ $t('appealoppsition.appeal.fields.step_02') }}</h2>
              <p>{{ $t('appealoppsition.appeal.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step03">
              <h2>{{ $t('appealoppsition.appeal.fields.step_03') }}</h2>
              <p>{{ $t('appealoppsition.appeal.fields.review_submit') }}</p>
            </v-flex>
            <v-flex class="step_box step04" v-if="paymentTabShow">
              <h2>{{ $t('appealoppsition.appeal.fields.step_04') }}</h2>
              <p>{{ $t('appealoppsition.appeal.fields.payment') }}</p>
            </v-flex>
          </v-layout>

          <v-layout class="inner_contents mt-30" column>
            <ApplicationInformation2 :receipt_no="receipt_no" />

            <ValidationObserver ref="observer1">
              <v-form>
                <v-flex class="item_box pa-0" v-show="requestFormShow" v-if="false">
                  <h2 class="m_title solo mt-35">{{ $t('appealoppsition.appeal.fields.request_form') }}</h2>
                  <template v-for="(item, index) in attachDocList">
                    <v-row v-if="item.ind_filing === 'Y'" class="ma-0 mt-15" :key="index">
                      <v-col class="pl-15 pr-15">
                        <h2 class="nec_title">&nbsp;<i v-if="item.ind_required === 'Y'">* </i>{{ $vuetify.rtl ? item.name_ar : item.name_en }}</h2>
                        <div class="d-flex mt-15">
                          <div class="input_text_type_basic file_type wp50">
                            <template v-for="(document_file, file_index) in item.document_files">
                              <div class="fileForm" :key="file_index" :class="{'mt-10' : file_index != 0}">
                                  <ValidationProvider v-slot="{ errors }" :name="$vuetify.rtl ? item.name_ar : item.name_en" :rules="{required: fnGetFormValid()}">
                                    <v-file-input
                                      :accept="fnGetAcceptExts(item.doc_exts)"
                                      solo
                                      outlined
                                      flat
                                      dense
                                      :placeholder="document_file.document_file_name ? document_file.document_file_name : $t('common.common.no_files_selected')"
                                      :prepend-icon="$t('common.common.select_file')"
                                      class="login_text_filed br_none ft-size12"
                                      v-model="document_file.file"
                                      :error-messages="errors"
                                      style="height: 40px;"
                                      :append-icon="document_file.document_file_name ? '$clear':''"
                                      @click:append="fnInitFileForm(document_file)"
                                      clearable
                                      @click:clear="fnInitFileForm(document_file)"
                                      @change="fnUploadFile(item, document_file)"
                                    ></v-file-input>
                                </ValidationProvider>
                              </div>
                              <div :key="file_index + '_btn'" >
                                <v-spacer class="hidden_lr5"></v-spacer>
                                <div v-if="item.ind_multi_upload === 'Y'">
                                  <v-btn
                                    color="#333"
                                    outlined
                                    width="70"
                                    height="40"
                                    class="ft-size12 text-capitalize lcolor-ddd br_none"
                                    @click="fnAddFileForm(item)"
                                     v-show="file_index === 0"
                                  >
                                    {{ $t('appealoppsition.appeal.fields.add_document') }}
                                  </v-btn>
                                  <v-btn
                                    color="#333"
                                    outlined
                                    width="70"
                                    height="40"
                                    class="ft-size12 text-capitalize lcolor-ddd br_none"
                                    @click="fnDelFileForm(document_file, file_index)"
                                     v-show="file_index > 0"
                                  >
                                    {{ $t('appealoppsition.appeal.fields.del_document') }}
                                  </v-btn>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </template>
                </v-flex>

                <v-flex class="item_box pa-0" style="border-bottom: none">
                  <h2 class="m_title solo mt-35"><i>*</i> {{ $t('appealoppsition.appeal.fields.type_of_appeal') }}</h2>
                  <v-col cols="12" class="pa-0 mt-20">
                    <div class="input_checkbox_type_basic radio_dailog_type row ma-0 pl-15 pr-15">
                      <ValidationProvider v-slot="{ errors }" :name="$t('appealoppsition.appeal.fields.type_of_appeal')" :rules="{required: true}">
                        <v-radio-group
                          row
                          v-model="appeal.appeal_type_code"
                          :error-messages="errors"
                        >
                          <template v-for="(item, index) in $vuetify.rtl ? appealTypeCodeAr : appealTypeCodeEn">
                            <v-radio
                              color="#a01c2a"
                              :key="item.value"
                              :label="item.text"
                              :value="item.value"
                            >
                            </v-radio>
                            <v-spacer class="hidden_lr10" :key="index" v-if="index > 0"></v-spacer>
                          </template>
                        </v-radio-group>
                      </ValidationProvider>
                    </div>
                  </v-col>
                </v-flex>

                <v-flex class="item_box pa-0" style="border-bottom: none" v-if="appeal.appeal_type_code === '5701'">
                  <h2 class="m_title solo mt-35"><i>*</i> {{ $t('appealoppsition.appeal.fields.egpo_action_information') }}</h2>
                  <v-row class="d-flex align-center pl-15 pr-15">
                    <v-col cols="12" md="2" class="pt-0 pb-0">
                      <h2 class="nec_title">{{ $t('appealoppsition.appeal.fields.egpo_decision_date') }}</h2>
                    </v-col>
                    <v-col cols="12" md="3" class="pb-0 pt-5">
                      <v-menu
                        v-model="decisionDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider v-slot="{ errors }" :name="$t('appealoppsition.appeal.fields.egpo_decision_date')" :rules="{required: (appeal.appeal_type_code === '5701')}">
                            <v-text-field
                              outlined
                              solo
                              dense
                              flat
                              hint="DD/MM/YYYY format"
                              v-bind="attrs"
                              v-on="on"
                              append-icon="mdi-calendar"
                              class="ft-size12 br_none"
                              v-model="appeal.appeal_decision_date"
                              :error-messages="errors"
                              @click:append="decisionDateMenu = true"
                              readonly
                            ></v-text-field>
                          </ValidationProvider>
                        </template>
                        <v-date-picker v-model="decisionDatePicker" no-title @input="fnSetDecisionDate()"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex align-center pl-15 pr-15">
                    <v-col cols="12" md="2" class="pt-0 pb-0">
                      <h2 class="nec_title">{{ $t('appealoppsition.appeal.fields.egpo_decision_name') }}</h2>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-5">
                      <ValidationProvider v-slot="{ errors }" :name="$t('appealoppsition.appeal.fields.egpo_decision_name')" :rules="{required: (appeal.appeal_type_code === '5701')}">
                        <v-text-field
                          placeholder=""
                          dense
                          outlined
                          clearable
                          class="ft-size12 br_none"
                          :error-messages="errors"
                          v-model="appeal.appeal_decision_name"
                        >
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-flex>

                <v-flex class="item_box pa-0" style="border-bottom: none" v-if="appeal.appeal_type_code === '5702'">
                  <h2 class="m_title solo mt-35">{{ $t('appealoppsition.appeal.fields.egpo_action_information') }}</h2>
                  <v-row class="d-flex align-center pl-15 pr-15">
                    <v-col cols="12" md="2" class="pt-0 pb-0">
                      <h2 class="nec_title"><i>*</i> {{ $t('appealoppsition.appeal.fields.egpo_decision_date') }}</h2>
                    </v-col>
                    <v-col cols="12" md="3" class="pb-0 pt-5">
                      <v-menu
                        v-model="decisionDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider v-slot="{ errors }" :name="$t('appealoppsition.appeal.fields.egpo_decision_date')" :rules="{required: (appeal.appeal_type_code === '5702')}">
                            <v-text-field
                              outlined
                              solo
                              dense
                              flat
                              hint="DD/MM/YYYY format"
                              v-bind="attrs"
                              v-on="on"
                              append-icon="mdi-calendar"
                              class="ft-size12 br_none"
                              v-model="appeal.appeal_decision_date"
                              :error-messages="errors"
                              @click:append="decisionDateMenu = true"
                              readonly
                            ></v-text-field>
                          </ValidationProvider>
                        </template>
                        <v-date-picker v-model="decisionDatePicker" no-title @input="fnSetDecisionDate()"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row class="d-flex align-center pl-15 pr-15">
                    <v-col cols="12" md="2" class="pt-0 pb-0">
                      <h2 class="nec_title">{{ $t('appealoppsition.appeal.fields.appeal_committee_date') }}</h2>
                    </v-col>
                    <v-col cols="12" md="3" class="pb-0 pt-5">
                      <v-menu
                        v-model="committeeDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <ValidationProvider v-slot="{ errors }" :name="$t('appealoppsition.appeal.fields.egpo_decision_date')" :rules="{required: false}">
                            <v-text-field
                              outlined
                              solo
                              dense
                              flat
                              hint="DD/MM/YYYY format"
                              v-bind="attrs"
                              v-on="on"
                              append-icon="mdi-calendar"
                              class="ft-size12 br_none"
                              v-model="appeal.appeal_committee_date"
                              :error-messages="errors"
                              @click:append="committeeDateMenu = true"
                              readonly
                            ></v-text-field>
                          </ValidationProvider>
                        </template>
                        <v-date-picker v-model="committeeDatePicker" no-title @input="fnSetCommitteeDate()"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-flex>

                <v-flex class="item_box pa-0" v-show="othersFormShow">
                  <h2 class="m_title solo mt-35">{{ $t('appealoppsition.appeal.fields.attachment') }}</h2>
                  <template v-for="(item, index) in attachDocList">
                    <v-row class="ma-0 mt-15" :key="index" v-if="(item.ipas_userdoc_code === '2011') ? (appeal.appeal_type_code === '5703') : true">
                      <v-col class="pl-15 pr-15">
                        <h2 class="nec_title">&nbsp;<i v-if="item.ind_required === 'Y' || (appeal.appeal_type_code === '5703' && item.ipas_userdoc_code === '2011')">* </i>{{ $vuetify.rtl ? item.name_ar : item.name_en }}</h2>
                        <div class="d-flex ft-size12 color_red" v-if="item.ind_required === 'Y' && item.spec_type_code === '4209'">
                          {{ $t('common.message.submit_poa') }}
                        </div>
                        <div class="d-flex mt-15">
                          <div class="input_text_type_basic file_type wp50">
                            <template v-for="(document_file, file_index) in item.document_files">
                              <div class="fileForm" :key="file_index" :class="{'mt-10' : file_index != 0}">
                                <ValidationProvider v-slot="{ errors }" :name="$vuetify.rtl ? item.name_ar : item.name_en" :rules="{required: (item.ind_required === 'Y' && !document_file.document_file_key) || (appeal.appeal_type_code === '5703' && item.ipas_userdoc_code === '2011' && !document_file.document_file_key) }">
                                  <v-file-input
                                    :accept="fnGetAcceptExts(item.doc_exts)"
                                    solo
                                    outlined
                                    flat
                                    dense
                                    :placeholder="document_file.document_file_name ? document_file.document_file_name : $t('common.common.no_files_selected')"
                                    :prepend-icon="$t('common.common.select_file')"
                                    class="login_text_filed br_none"
                                    v-model="document_file.file"
                                    :error-messages="errors"
                                    :append-icon="document_file.document_file_name ? '$clear':''"
                                    @click:append="fnInitFileForm(document_file)"
                                    clearable
                                    @click:clear="fnInitFileForm(document_file)"
                                    @change="fnUploadFile(item, document_file)"
                                    style="height: 40px;"
                                  ></v-file-input>
                                </ValidationProvider>
                              </div>
                              <div :key="file_index + '_btn'" >
                                <v-spacer class="hidden_lr5"></v-spacer>
                                <div v-if="item.ind_multi_upload === 'Y'">
                                  <v-btn
                                    color="#333"
                                    outlined
                                    width="70"
                                    height="40"
                                    class="ft-size12 text-capitalize lcolor-ddd br_none"
                                    @click="fnAddFileForm(item)"
                                     v-show="file_index === 0"
                                  >
                                    {{ $t('appealoppsition.appeal.fields.add_document') }}
                                  </v-btn>
                                  <v-btn
                                    color="#333"
                                    outlined
                                    width="70"
                                    height="40"
                                    class="ft-size12 text-capitalize lcolor-ddd br_none"
                                    @click="fnDelFileForm(document_file, file_index)"
                                     v-show="file_index > 0"
                                  >
                                    {{ $t('common.button.delete') }}
                                  </v-btn>
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </template>
                </v-flex>
              </v-form>
            </ValidationObserver>
          </v-layout>

          <v-row class="d-block">
            <v-col cols="12" class="mt-40 d-flex">
              <v-spacer></v-spacer>
              <v-btn
                color="#a01c2a"
                min-width="150"
                min-height="50"
                class="btn-normal br_none"
                style="color: #FFF"
                @click="fnGoNextStep()"
              >{{ $t('common.button.next') }}</v-btn>
            </v-col>
          </v-row>

        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ApplicationInformation2 from '@/components/layout/ApplicationInformation2'

export default {
  name: 'AppaealStep2',
  components :{
    ValidationObserver,
    ValidationProvider,
    ApplicationInformation2
  },
  data() {
    return {
      paymentTabShow : false,
      decisionDateMenu: false,
      decisionDatePicker: '',
      committeeDateMenu: false,
      committeeDatePicker: '',

      //application 검색결과
      search : {
        application_no : '',
        title_ar : '',
        title_en : '',
        applicant_name_list_ar : '',
        applicant_name_list_en : ''
      },
      receipt_no : this.$route.params.receipt_no,

      attachDocList: [],
      appealTypeCodeEn: [],
      appealTypeCodeAr: [],

      requestFormShow : false,
      othersFormShow : false,
      appeal: {
        seq: null,
        amend_seq: null,
        appeal_committee_date: '',
        appeal_decision_date: '',
        appeal_decision_name: '',
        appeal_type_code: ''
      }
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
    fnInit() {
      let options = {
        upper_code: '5700'
      }
      utils.fnGetCodeList(options).then(list => {
        this.appealTypeCodeAr = list.ar
        this.appealTypeCodeEn = list.en
      })

      this.fnGetReceipt()
      this.fnGetAppeal()
      this.fnGetAttachDocList()
      this.fnGetPayMentYn()
    },
    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6415'
              || res.data.receipt_status_type_code !== '4301') {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAppeal() {
      requestApi({
        url: '/receivings/appeal/'+ this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.appeal = {
              seq: res.data.seq,
              amend_seq: res.data.amend_seq,
              appeal_committee_date: res.data.appeal_committee_date,
              appeal_decision_date: res.data.appeal_decision_date,
              appeal_decision_name: res.data.appeal_decision_name,
              appeal_type_code: res.data.appeal_type_code
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAppeal()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetPayMentYn(){
      requestApi({
        url: '/receivings/' + this.receipt_no + '/fee',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            if(res.data.payment_fee_type_code === '4502'){
              this.paymentTabShow = true
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPayMentYn()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetAttachDocList(){
      requestApi({
        url: '/receivings/' + this.receipt_no + '/documents',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            let attachDocList = res.data.list

            this.requestFormShow = attachDocList.filter( item => item.ind_filing === 'Y' ).length > 0
            this.othersFormShow  = attachDocList.filter( item => item.ind_filing === 'N' ).length > 0

            attachDocList.forEach( item => {
              if(item.document_files.length === 0){
                //넘겨받은 데이터에서 파일 목록이 없을 경우 초기 셋팅을 해야 한다
                let defaultForm = {
                  document_file_seq : '',
                  document_file_key : '',
                  document_file_name : '',
                  file : null
                }
                item.document_files.push(defaultForm)
              }else{
                //넘겨받은 데이터에서 파일 목록이 있을 경우 파일폼만 추가
                item.document_files.forEach( doc_item => {
                  doc_item.file = null
                })
              }
            })

            this.attachDocList = attachDocList

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAttachDocList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnGetAcceptExts(doc_exts){
      let accept = ''

      doc_exts.forEach(item => {
        if(accept.length > 0){
          accept = accept + ","
        }
        accept = accept + "."+item.name_en
      })

      return accept
    },

    fnUploadFile(item, documentFile) {
      let fileExts = item.doc_exts
      let uploadFile = documentFile.file
      let specTypeCode = item.spec_type_code
      let langTypeCode = item.lang_type_code

      if(uploadFile != null){
        if (utils.getFileExtLen(uploadFile, fileExts, this.$t('common.message.file_extension_error')) === -1) {
          setTimeout(() => {
            documentFile.file = null
            documentFile.document_file_key = ''
            documentFile.document_file_name = ''
          }, 100)

          return
        }

        let formData = new FormData()
        formData.append("file_data", uploadFile)
        formData.append("spec_type_code", specTypeCode)
        formData.append("lang_type_code", langTypeCode)

        requestApi({
          url: '/file/documents/upload',
          method: 'POST',
          data: formData,
          headers : {"Content-Type":"multipart/form-data"},
          callback: (res) => {
            if (res.res_code === '200') {
              documentFile.document_file_key = res.data.file_key
            }else{
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnUploadFile(item, documentFile)
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                documentFile.file = null
                documentFile.document_file_key = ''
                documentFile.document_file_name = ''
              }
            }
          }
        })
      }

    },

    fnInitFileForm(documentFile) {
      documentFile.document_file_key = ''
      documentFile.document_file_name = ''
      documentFile.file = null
      documentFile.pdf_file_name = ''
      documentFile.pdf_file_path = ''
    },

    fnAddFileForm(item){
      let defaultForm = {
        document_file_seq : '',
        document_file_key : '',
        document_file_name : '',
        file : null
      }
      item.document_files.push(defaultForm)
    },

    fnDelFileForm(documentFile, index){
      documentFile.splice(index, 1)
    },

    fnGoNextStep(){
      this.$refs.observer1.validate().then((valid) => {
        if(valid){
          let params = this.appeal
          requestApi({
            url: '/receivings/appeal/'+ this.receipt_no,
            method: 'PUT',
            data: params,
            callback: (res) => {
              if (res.res_code === '200') {
                this.fnUploadAttachDoc()
              }else{
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.fnGoNextStep()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        } else {
          //2020-11-03 : 첫번째 에러 항목으로 Focus 되도록 추가 수정 (vee-validate 3.0 기반)
          document.getElementsByClassName('error--text')[0].scrollIntoView(false)
        }
      })
    },

    fnUploadAttachDoc () {
      let params = []
      let attachDocList = this.attachDocList
      for(let i=0; i<attachDocList.length; i++){
        for(let k=0; k<attachDocList[i].document_files.length; k++){
          let paramItem = {
            user_document_config_seq : attachDocList[i].user_document_config_seq,
            document_seq : attachDocList[i].document_seq,
            document_file_seq : attachDocList[i].document_files[k].document_file_seq,
            document_file_key : attachDocList[i].document_files[k].document_file_key,
            ind_multi_upload: attachDocList[i].ind_multi_upload
          }
          params.push(paramItem)
        }
      }
      requestApi({
        url: '/receivings/appeal/' + this.receipt_no + '/documents',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.$router.push({path : '/appeal/step3/' + this.receipt_no })
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnUploadAttachDoc()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },


    fnIsNotNull(value){
      return !utils.isNull(value)
    },

    fnGetFormValid() {
      let bln = true
      this.attachDocList.forEach((item) => {
        if (item.ind_filing === 'Y') {
          item.document_files.forEach((files) => {
            if (files.document_file_key !== '') {
              bln = false
            }
          })
        }
      })
      return bln
    },

    fnSetDecisionDate() {
      this.appeal.appeal_decision_date = this.$moment(this.decisionDatePicker).format('DD/MM/YYYY')
      this.decisionDateMenu = false
    },

    fnSetCommitteeDate() {
      this.appeal.appeal_committee_date = this.$moment(this.committeeDatePicker).format('DD/MM/YYYY')
      this.committeeDateMenu = false
    }
  }
}
</script>